import { DEVICE_MANAGEMENT_FEATURE_FLAG } from 'core/service/feature-flag/feature-flag.constants';
import { isFeatureFlagActive } from 'core/service/feature-flag/feature-flag.utils';
import { getDeviceFilterAlarms, getOperatorFilterAlarms } from 'core/service/user-preferences/user-preferences.service';
import { SideMenuAlarm } from 'core/service/user-preferences/domain/model/side-menu-alarm.model';
import { useFeatureFlagsContext } from 'core/contexts/feature-flags/hooks/use-feature-flags-context.hook';
import { QUERY_KEYS } from 'core/query-client/query-keys.constants';
import { executeRequest } from 'core/utils/backend-service';
import { usePocQuery } from './use-poc-query.hook';

interface UseSideMenuAlarmsResponse {
    sideMenuAlarms: Record<string, SideMenuAlarm>;
    isLoading: boolean;
}

const fetchSideMenuAlarms = async (isDeviceManagementEnabled: boolean): Promise<Record<string, SideMenuAlarm>> => {
    const [operatorAlarms, deviceAlarms] = await Promise.all([
        getOperatorFilterAlarms(),
        isDeviceManagementEnabled ? getDeviceFilterAlarms() : Promise.resolve({}),
    ]);
    return { ...operatorAlarms, ...deviceAlarms };
};

const EMPTY_ALARMS: Record<string, SideMenuAlarm> = {};

export const useSideMenuAlarms = (): UseSideMenuAlarmsResponse => {
    const { featureFlags } = useFeatureFlagsContext();
    const isDeviceManagementEnabled = isFeatureFlagActive(featureFlags, DEVICE_MANAGEMENT_FEATURE_FLAG);

    const { data, isLoading } = usePocQuery<Record<string, SideMenuAlarm>>({
        queryKey: [...QUERY_KEYS.ALARMS, isDeviceManagementEnabled],
        queryFn: () => executeRequest(() => fetchSideMenuAlarms(isDeviceManagementEnabled)),
    });

    return { sideMenuAlarms: data ?? EMPTY_ALARMS, isLoading };
};
